import { Capacitor } from '@capacitor/core';

// Leaderboard IDs — configure these in Google Play Console and App Store Connect
export const LEADERBOARD_IDS = {
    // Android (Google Play Games Services): create in Play Console > Services > Play Games Services > Leaderboards
    android: 'YOUR_ANDROID_LEADERBOARD_ID', // e.g. 'CgkI...'
    // iOS (Game Center): set this to the leaderboard ID you create in App Store Connect
    ios: 'com.balconygames.survival.leaderboard'
};

export class GameServices {
    constructor() {
        this.isNative = Capacitor.isNativePlatform();
        this.platform = Capacitor.getPlatform();
        this.plugin = null;
        this.signedIn = false;
        this.playerID = null;
    }

    async initialize() {
        if (!this.isNative) return false;

        try {
            // Dynamically import so web builds don't break if plugin is absent
            const { GameConnect } = await import('@openforge/capacitor-game-connect');
            this.plugin = GameConnect;

            await this.plugin.signIn();
            this.signedIn = true;

            const info = await this.plugin.getPlayerID();
            this.playerID = info?.playerID ?? null;

            console.log('GameServices: signed in, playerID =', this.playerID);
            return true;
        } catch (error) {
            console.warn('GameServices: initialization failed:', error);
            return false;
        }
    }

    async submitScore(score) {
        if (!this.plugin || !this.signedIn) return;

        const leaderboardID = this.platform === 'ios'
            ? LEADERBOARD_IDS.ios
            : LEADERBOARD_IDS.android;

        try {
            await this.plugin.submitScore({
                leaderboardID,
                totalScoreAmount: score
            });
            console.log('GameServices: score submitted:', score);
        } catch (error) {
            console.warn('GameServices: submitScore failed:', error);
        }
    }

    async showLeaderboard() {
        if (!this.plugin || !this.signedIn) return false;

        const leaderboardID = this.platform === 'ios'
            ? LEADERBOARD_IDS.ios
            : LEADERBOARD_IDS.android;

        try {
            await this.plugin.showLeaderboard({ leaderboardID });
            return true;
        } catch (error) {
            console.warn('GameServices: showLeaderboard failed:', error);
            return false;
        }
    }

    isAvailable() {
        return this.isNative && this.signedIn;
    }
}
